import React, {useState,useEffect} from 'react';
import { Table,TableBody,TableHeader,TableCell,DataTableCell } from '@david.kucsai/react-pdf-table';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import * as calc from '../../utils/calcolatrice'

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  cella: {
    textAlign: 'center'
  },
  textCenter: {
    textAlign: 'left',
    marginTop: 20,
    marginBottom: 20
  },
  text: {
    textAlign: 'left',
    marginTop: 10,
    marginBottom: 10
  }
});

// Create Document Component
const MyDocument = (props) => {

  const {ruota,corona, rpm, binary = false, pignoni,setPignoni,invertiCalcolo,en} = props

  const [rows,setRows] = useState([])
  const [rowsBinary,setRowsBinary] = useState([])

  const msToKmh = (speedMs) => (speedMs * 3600) / 1000;

  const generaRighe = (pignoni,ruota,corona,rpm,binary = false) => {


      return pignoni.map(pignone => {

        let rapporto = 1

        if(invertiCalcolo) {
            rapporto = (binary) ? (corona/pignone)*1.25  : (corona/pignone)
        }
        else {
            rapporto = (binary) ? (corona/pignone)/1.25  : (corona/pignone)
        }
          const sviluppo = ruota.sviluppo
          const speed = msToKmh(calc.calcSpeedByRpmSprocketsWheelCircumference(rpm,rapporto,sviluppo,binary))


          return {sviluppo: (Math.round((rapporto*sviluppo))/1000), speed,pignone}
          

      })


  }

  useEffect(() => {
    setRows(generaRighe(pignoni,ruota,corona,rpm,false))
    setRowsBinary(generaRighe(pignoni,ruota,corona,rpm,true))

},[ruota,corona, rpm,pignoni])

  return (
    <Document>
      <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        
        <Text style={styles.text}>Ruota impostata: {ruota.tipo}</Text>
        <Text style={styles.text}>Corona impostata: {Math.round(corona)}</Text>
        <Text style={styles.text}>Rpm: {Math.round(rpm)}</Text>
        {invertiCalcolo ? <Text style={styles.textCenter}>Corona - Velocità 1: {Math.round(corona)}</Text> : <Text style={styles.textCenter}>Corona - senza sistema: {Math.round(corona)}</Text>}
        <Table data={rows}>
                  <TableHeader>
                  <TableCell style={styles.cella}>
                          Pignone
                      </TableCell>
                      <TableCell style={styles.cella}>
                          Velocità
                      </TableCell>
                      <TableCell style={styles.cella}>
                          Sviluppo Metrico
                      </TableCell>
                  </TableHeader>
                  <TableBody>
                      <DataTableCell style={styles.cella} getContent={(r) => r.pignone}/>
                      <DataTableCell style={styles.cella} getContent={(r) => r.speed > 0 ? r.speed.toFixed(2) + ' Km/h' : 'N/D'}/>
                      <DataTableCell style={styles.cella} getContent={(r) => r.sviluppo + ' m'}/>
                  </TableBody>
        </Table>
        {invertiCalcolo ? <Text style={styles.textCenter}>Corona - Velocità 2: {Math.round(corona*1.25)}</Text> : <Text style={styles.textCenter}>Corona - con sistema Binary: {Math.round(corona/1.25)}</Text>}
        {!invertiCalcolo && <Text style={styles.textCenter}>Corona da montare fisicamente sulla bici: {Math.round(corona/1.25)}</Text>}
        <Table data={rowsBinary}>
                  <TableHeader>
                      <TableCell style={styles.cella}>
                          Pignone
                      </TableCell>
                      <TableCell style={styles.cella}>
                          Velocità
                      </TableCell>
                      <TableCell style={styles.cella}>
                          Sviluppo metrico
                      </TableCell>
                  </TableHeader>
                  <TableBody>
                      <DataTableCell style={styles.cella} getContent={(r) => r.pignone}/>
                      <DataTableCell style={styles.cella} getContent={(r) => r.speed > 0 ? r.speed.toFixed(2) + ' m' : 'N/D'}/>
                      <DataTableCell style={styles.cella} getContent={(r) => r.sviluppo + ' m'}/>
                  </TableBody>
        </Table>
      </View>
      </Page>
    </Document>
  );
} 

export default MyDocument